var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"height-100",attrs:{"app":""}},[_c('top-menu'),_c('v-container',{staticClass:"py-0 px-0 px-md-3",attrs:{"fluid":"","fill-height":"","align-start":""}},[_c('v-container',{staticClass:"pa-0 px-lg-3",attrs:{"fill-height":"","align-start":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }